import * as types from './mutation-types'
import Vue from 'vue'
import { IMissionVirtualState } from './state'
import { MutationTree } from 'vuex/types'
import { AloDbMissionVirtual, IAloDbMissionVirtualConstParam } from '@/models/alodb/AloDbMissionVirtual';
import glider from '@/api/glider';
import { WobSimProgress } from '@/models/wob/WobSimProgress';
import { AloMission, calculAllDomainsData } from '@/models/alo/AloMission';
import { boundingExtent } from 'ol/extent';
import { getDefaultSmartResult } from '@/models/iris/smartMission/ISmartResult';
import { getSimulationStatus, SimulationStatus } from '@/enum/SimulationStatus';
import {i18n} from '@/locale/vueI18n'

/*
  Need to use export default({}) rather than export default {}
  ref links: https://github.com/TypeStrong/ts-loader/issues/588
*/
const mutations:MutationTree<IMissionVirtualState> = {
     
    //Gestion des recherches de missions
    [types.MISSIONVIRTUAL_REQUEST]: state => {
        state.status = i18n.t('Admin.Loading',{item:i18n.t('Admin.Simulation.Title').toString()}).toString()
        state.missionVirtualLoading = true
    },
    [types.MISSIONVIRTUAL_SUCCESS]: (state, missionVirtuals:Array<AloDbMissionVirtual>) => {
        state.status = i18n.t('Admin.LoadingOk',{item:i18n.t('Admin.Simulation.Title').toString()}).toString()
        //on remplace les missions de la reponse par les missions du store déja présente    
        state.missionVirtuals.forEach(m => {
            const idx = missionVirtuals.findIndex((rm) => rm.id == m.id && m.mission._detailLoaded)
            if(idx >= 0) {        
                missionVirtuals.splice(idx, 1, m)        
            }
        })                
        state.missionVirtuals = missionVirtuals   
        state.missionVirtualLoading = false             
    },
    [types.MISSIONVIRTUAL_ERROR]: state => {
        state.status = i18n.t('Admin.LoadingError',{item:i18n.t('Admin.Simulation.Title').toString()}).toString()
        state.missionVirtuals = []
        state.missionVirtualLoading = false
    },
    [types.MISSIONVIRTUAL_SELECT_DETAIL_REQUEST]: (state, itemId:number) => {
        state.status = i18n.t('Admin.Loading',{item:`${i18n.t('Admin.Simulation.Title').toString()} ${itemId}`}).toString()
        state.missionVirtualLoading = true
    },
    [types.MISSIONVIRTUAL_SELECT_DETAIL_ERROR]: state => {
        state.status = i18n.t('Admin.LoadingError',{item:i18n.t('Admin.Simulation.Title').toString()}).toString()
        state.missionVirtualLoading = false
    },
    [types.MISSIONVIRTUAL_SELECT_DETAIL_SUCCESS]: (state,missionVirtual:AloDbMissionVirtual) => {
        state.status = i18n.t('Admin.LoadingOk',{item:`${i18n.t('Admin.Simulation.Title').toString()} ${missionVirtual.id}`}).toString()        
        //1, on met à jour de m'missionVirtual dans la liste des missionVirtuals
        const index = state.missionVirtuals.findIndex(m => m.id == missionVirtual.id)
        state.missionVirtuals.splice(index == -1 ? state.missionVirtuals.length : index, index == -1 ? 0 : 1, missionVirtual)
        state.missionVirtualLoading = false
    },
    [types.MISSIONVIRTUAL_SELECT_DETAIL]: (state,missionVirtual:AloDbMissionVirtual) => {                
        state.originalAdmMissionVirtual = missionVirtual        
        //@ts-ignore
        state.modifiedAdmMissionVirtual = new AloDbMissionVirtual({...missionVirtual,VIM_DATADD:missionVirtual.VIM_DATADD?missionVirtual.VIM_DATADD.toUTCString():null,VIM_DATDEL:missionVirtual.VIM_DATDEL?missionVirtual.VIM_DATDEL.toUTCString():null} as IAloDbMissionVirtualConstParam )
    },
    [types.MISSIONVIRTUAL_SAVE_REQUEST]: (state,libelle:string) => {
        state.status = i18n.t('Admin.SaveItem',{item:`${i18n.t('Admin.Simulation.Title').toString()} ${libelle}`}).toString()
        state.missionVirtualLoading = true
    },
    [types.MISSIONVIRTUAL_SAVE_ERROR]: state => {
        state.status = i18n.t('Admin.ErrorSave',{item:i18n.t('Admin.Simulation.Title').toString()}).toString()
        state.missionVirtualLoading = false
    },
    [types.MISSIONVIRTUAL_UPDATE_MODIFIED_ADM]: (state, newProperties:Object) => {        
        state.modifiedAdmMissionVirtual = {...state.modifiedAdmMissionVirtual,...newProperties}
    },
    [types.MISSIONVIRTUAL_UPDATE_FILTER_ADM]: (state, newProperties:Object) => {        
        state.adminFilter = {...state.adminFilter,...newProperties}
    },
    [types.MISSIONVIRTUAL_UPDATE_PROGRESSION]: (state,{missionvirtual,wob}:{missionvirtual:AloDbMissionVirtual,wob:WobSimProgress}) => {                
        if(missionvirtual) {
            missionvirtual.VIM_RESULT_JSON = wob.irisRawResult
            missionvirtual.result = {...getDefaultSmartResult(),...wob.irisResult ?? {} } 
               
            //@ts-ignore
            missionvirtual.mission = AloDbMissionVirtual.buildAloMission(missionvirtual,true)
            missionvirtual.VIM_STATUS = getSimulationStatus(wob.simulationState)            
            missionvirtual.mission._detailLoaded = missionvirtual.VIM_STATUS < 0 || missionvirtual.VIM_STATUS == 10           
            // if(wob.irisResult == null)  {
            //     //tente de mettre à jour le vim_status
            //     if(wob.simulationState == "downloading_netcdf") missionvirtual.VIM_STATUS = 3
            //     missionvirtual.mission._detailLoaded = missionvirtual.VIM_STATUS < 0 || missionvirtual.VIM_STATUS == 10
            // }
        }        
    },
    [types.MISSIONVIRTUAL_RESET_SHOW_DIALOG_FINISHED]: state => {
        state.showDialogSimulationFinished = ''
    },
    [types.MISSIONVIRTUAL_PROGRESSION_REQUEST]: (state, itemId:number) => {
        state.status = `loading missionVirtual result ${itemId}`
        state.missionVirtualLoading = true
    },
    [types.MISSIONVIRTUAL_PROGRESSION_ERROR]: state => {
        state.status = 'error loading missionVirtual result'
        state.missionVirtualLoading = false
    },
    [types.MISSIONVIRTUAL_DELETE_REQUEST]: (state,libelle:string) => {
        state.status = i18n.t('Admin.DeleteItem',{item:`${i18n.t('Admin.Simulation.Title').toString()} ${libelle}`}).toString()        
        state.missionVirtualLoading = true
    },
    [types.MISSIONVIRTUAL_DELETE_SUCCESS]: (state,misId:number) => {
        state.status = i18n.t('Admin.DeleteItemOk',{item:`${i18n.t('Admin.Simulation.Title').toString()} ${misId}`}).toString()
        const index = state.missionVirtuals.findIndex(l => l.id == misId)
        state.missionVirtuals.splice(index == -1 ? state.missionVirtuals.length : index, index == -1 ? 0 : 1)
        state.missionVirtualLoading = false
    },
    [types.MISSIONVIRTUAL_DELETE_ERROR]: state => {
        state.status = i18n.t('Admin.ErrorDelete',{item:i18n.t('Admin.Simulation.Title').toString()}).toString()
        state.missionVirtualLoading = false
    },
    [types.MISSIONVIRTUAL_DATA_SCIENCE_REQUEST]: (state, id:number) => {
        state.status = `loading science data for missionVirtual ${id}`
        const index = state.missionVirtuals.findIndex(m => m.id == id)
        if (index > -1) {
            const mission = state.missionVirtuals[index].mission
            mission._dataScienceLoading = true
        }
    },
    [types.MISSIONVIRTUAL_DATA_SCIENCE_SUCCESS]: (state, { id, datas, targetYosCycles }:{ id:number, datas:any, targetYosCycles:Array<number>|null }) => {
      state.status = `success loading science data for missionVirtual ${id}`
      
      //Mise à jour des données sciences de la mission
      const index = state.missionVirtuals.findIndex(m => m.id == id)
      if (index > -1) {
        const mission = state.missionVirtuals[index].mission
  
        //Si la mission a deja des données sciences on est dans le cas d'une mise à jour ou d'un ajout
        if(targetYosCycles && mission.dataScience.length > 0){
          //const yosCycles = extractDistinctNumberProp(datas,d => d.yosCycle)
          datas = [...mission.dataScience.filter(d => targetYosCycles.every(y => y != d.yosCycle)),...datas].sort((a,b) => a.PLD_REALTIMECLOCK.getTime() - b.PLD_REALTIMECLOCK.getTime())
        }      
        
        calculAllDomainsData(
          mission.sciPlotVariables,
          mission.xSciScatterVariable,
          mission.domains,
          mission.domainsAutoScale,
          mission.domainsColor,
          datas
        )            
        mission.dataScience = datas
        mission._dataScienceLoaded = true            
        mission._dataScienceLoading = false   
      }
    },
    [types.MISSIONVIRTUAL_DATA_SCIENCE_ERROR]: (state, id:number) => {
      state.status = `error loading science data for missionVirtual ${id}`
      const index = state.missionVirtuals.findIndex(m => m.id == id)
      if (index > -1) {
        const mission = state.missionVirtuals[index].mission
        mission._dataScienceLoading = false   
      }
    }
}


export default mutations